import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { saveFunnerUserDetails } from 'api/app-users';
import { dispatch, store } from 'store';
import { ApplicationUser } from 'types/company/applicationUser';
import { fetcher } from 'utils/axios';

const initialState: ApplicationUser[] = [];

const applicationUsersSlice = createSlice({
  name: 'applicationUsers',
  initialState,
  reducers: {
    setApplicationUsers(state, action: PayloadAction<ApplicationUser[]>) {
      return action.payload;
    },
    updateSingleApplicationUser(
      state,
      action: PayloadAction<{ userId: string; params: Partial<ApplicationUser> }>,
    ) {
      const { userId, params } = action.payload;
      return state.map((appUser) => {
        if (appUser.Udid === userId) {
          return { ...appUser, ...params };
        }
        return appUser;
      });
    },
    resetApplicationUsers() {
      return initialState;
    },
  },
});

export default applicationUsersSlice.reducer;
export const { setApplicationUsers, updateSingleApplicationUser, resetApplicationUsers } =
  applicationUsersSlice.actions;

export async function getApplicationUsers() {
  try {
    const data = await fetcher('get', '/api/auth/getApplicationUsers', 'history');
    if (data?.result) {
      dispatch(setApplicationUsers(data.users));
    }
  } catch (error) {
    console.warn('getCompanyData err: ', error);
  }
}
export async function fetchUpdateApplicationUser(userId: string, params: Partial<ApplicationUser>) {
  try {
    const user = store.getState().applicationUsers.find((user) => user.Udid === userId);
    if (!user) return;

    const newUser = { ...user, ...params };
    const data = await saveFunnerUserDetails(newUser);
    if (data) {
      dispatch(updateSingleApplicationUser({ userId, params }));
    }
  } catch (error) {
    console.warn('getCompanyData err: ', error);
  }
}
